import { calcSellerPayout } from '../utils/sellerPayout'
import { useTranslation } from 'react-i18next'

type Props = {
  price: string
  shippingDeductionEur?: number
}

export default function SellerPayoutPreview({ price, shippingDeductionEur = 0 }: Props) {
  const { t } = useTranslation()
  const n = parseFloat(String(price).replace(',', '.'))
  if (!Number.isFinite(n) || n <= 0) return null
  const { receives } = calcSellerPayout(n, shippingDeductionEur)
  const shipHint =
    shippingDeductionEur > 0
      ? t('listing.sellerPayoutShip', { ship: shippingDeductionEur.toFixed(2) })
      : ''
  return (
    <div className="seller-payout-preview" role="status">
      <p className="seller-payout-preview__amount">
        {t('listing.sellerPayoutPreview', { amount: receives.toFixed(2) })}
      </p>
      <p className="seller-payout-preview__hint">
        {t('listing.sellerPayoutFreeHint')}
        {shipHint}
      </p>
    </div>
  )
}
